const STORAGE_KEY = "other-store-recent-orders";

function readAll() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeAll(data) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore quota errors */
  }
}

export function saveRecentStoreOrder(storeId, orderId, accessToken) {
  if (!storeId || !orderId) {
    return;
  }
  const all = readAll();
  all[storeId] = {
    orderId,
    accessToken: accessToken || null,
    savedAt: Date.now(),
  };
  writeAll(all);
}

export function getRecentStoreOrder(storeId) {
  if (!storeId) {
    return null;
  }
  return readAll()[storeId] ?? null;
}

export function getRecentStoreOrderId(storeId) {
  return getRecentStoreOrder(storeId)?.orderId ?? null;
}

export function getRecentStoreOrderToken(storeId) {
  return getRecentStoreOrder(storeId)?.accessToken ?? null;
}
